import React, { FC } from 'react';

import Modal from '~components/atoms/Modal';

import CreateGoldConversionForm from '../CreateGoldConversionForm';

type GoldConversionModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const GoldConversionModal: FC<GoldConversionModalProps> = ({
    isOpen,
    onClose,
}) => {

    return (
        <Modal
            testId='conversion-create-close-modal'
            isOpen={isOpen}
            onClose={onClose}
            title='Create Conversion'
        >
            <CreateGoldConversionForm />
        </Modal>
    );
};

export default GoldConversionModal;
